module.exports = __webpack_public_path__ + "static/img/SP.0a9fcc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/SP.png
// module id = XhWl
// module chunks = 34